import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Table, {
    TableHeader,
    TableHeaderRow,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell
} from 'calcite-react/Table'

import Search from 'calcite-react/Search';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import fieldsDefinition from '../arcgisFilter/defaults/incidentFields.json';
import moment from 'moment';

 const specialTitlesMap = {
            InformLastModifiedDate: "InFORM Last Modified Date",
            IsCauseProhibited: "Is Cause Prohibited",
            FireCauseSpecificDetailID: "Fire Cause Specific Detail",
            FireCauseAgeCategoryID: "Fire Cause Age Category",
            FireCauseActivityGroupID: "Fire Cause Activity Group"
        };

class EditLogDialog extends Component {

    constructor(props) {
        super(props)
        this.state =
        {
            searchIdentifer: null,
            searchValue: '',
            filterFields: [],
            showEditInfo: false,
            editInfoPackage: null,
            userFilterField: null
        };

        this.updateSearchValue = this.updateSearchValue.bind(this);
        this.onUserAction = this.onUserAction.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    componentWillReceiveProps(nextProps) 
    {
        if (nextProps.editInfoPackage !== this.props.editInfoPackage) 
            {
            if (nextProps.editInfoPackage === null || nextProps.editInfoPackage.EditEvents === null || nextProps.editInfoPackage.EditEvents.length === 0) 
                {
                this.setState({
                    filterFields: []
                });
                return;
            }
            let newFilterFields = [];
            for (var i = 0; i < nextProps.editInfoPackage.EditEntries.length; i++) 
                {
                if (newFilterFields.indexOf(nextProps.editInfoPackage.EditEntries[i].Attribute) === -1) 
                    {
                        newFilterFields.push(nextProps.editInfoPackage.EditEntries[i].Attribute);
                    }
                }
            this.setState({
                filterFields: newFilterFields
            });
        }
    }

    onUserAction(value) {
        this.setState({
            searchValue: value
        });
    }

    clearSearch() {
        this.setState({
            searchValue: '',
            userFilterField: null,
        })
    }

    updateSearchValue = (value) => {
        this.setState({
            searchValue: value,
            userFilterField: value
        });
    }

       

    getTitleForAttributeName = (attributeName) => {
        if (specialTitlesMap.hasOwnProperty(attributeName)) {
            return specialTitlesMap[attributeName];
        }

        const fieldObject = fieldsDefinition[attributeName];
        return fieldObject?.alias ?? attributeName;
    };

    getDisplayValue = (attributeName, value) => {
        if (attributeName === "InformLastModifiedDate") {
            return (value) ? moment(new Date(parseInt(value))).format("MM/DD/YYYY h:mm A") : "NULL";
        }

        const fieldObject = fieldsDefinition[attributeName];
        if (fieldObject !== undefined && fieldObject !== null) {
            if (fieldObject.domain !== undefined && fieldObject.domain !== null) {
                try {
                    const codedValue = fieldObject.domain.codedValues.find(codedValue => codedValue.code.toString() === value.toString());
                    return (codedValue) ? codedValue.name : value;
                }

                catch (err) {
                    return (value === null || value === undefined) ? "NULL" : value;
                }
            }

            switch (fieldObject.type) {
                case "esriFieldTypeDate":
                    return (value && value !== "") ? moment(new Date(parseInt(value))).format("MM/DD/YYYY h:mm A") : "NULL";
                default:
                    return value;
            }
        } else {
            return value;
        }
    }

    getFilteredEditLog = (editLogEntries) => {
        return (
            <Table>
                <TableHeader>
                    <TableHeaderRow>
                        <TableHeaderCell><b>Attribute</b></TableHeaderCell>
                        <TableHeaderCell><b>Changed From</b></TableHeaderCell>
                        <TableHeaderCell><b>Changed To</b></TableHeaderCell>
                    </TableHeaderRow>
                </TableHeader>
                <TableBody>
                    {editLogEntries.map(editLog => {
                        return (
                            <TableRow>
                                <TableCell>{this.getTitleForAttributeName(editLog.Attribute)}</TableCell>
                                <TableCell>{(editLog.OldValue === null || editLog.OldValue === "") ? "NULL" : this.getDisplayValue(editLog.Attribute, editLog.OldValue)}</TableCell>
                                <TableCell>{this.getDisplayValue(editLog.Attribute, editLog.NewValue)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        )

    }
    getUserEditContent = () => {
        const content = (this.props.editInfoPackage.EditEvents.length > 0) ?
            (
                this.props.editInfoPackage.EditEvents.map(editEvent => {
                    const editID = editEvent.EditID;
                    const filteredEditLog = this.props.editInfoPackage.EditEntries.filter(entry => entry.EditID === editID);
                    const hasUserFilter = (this.state.userFilterField !== null);
                    const editEventContainsFilter = (hasUserFilter) ? filteredEditLog.find(entry => entry.Attribute === this.state.userFilterField) : true;
                    
                    return (editEventContainsFilter) ? (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header">
                                <Typography>{editEvent.UserName} at {moment(editEvent.EditDate).format("MM/DD/YYYY h:mm A")}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {this.getFilteredEditLog(filteredEditLog)}
                            </AccordionDetails>
                        </Accordion>
                    ) : "";
                })
            ) : "";
        return content;
  }

  onClose = () => {
    this.props.onClose();
  }

  render() {
    
    if (!this.props.open || !this.props.editInfoPackage) 
    {
        return null;
    }

    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={this.onClose}
      />
    ];

    const content =
    (
        <div style={{ minHeight: 700, width: 900 }}>
            Fire Occurence Record ID: {this.props.editInfoPackage.FireOccurenceRecord.FireOccurenceRecordID}<br />
            Incident Name: {this.props.editInfoPackage.FireOccurenceRecord.IncidentName}<br /><br />
            <div>
                Filter Attribute: <Search fullWidth onRequestClear={this.clearSearch} items={this.state.filterFields} onChange={this.updateSearchValue} inputValue={this.state.searchValue} onUserAction={this.onUserAction} />
            </div>
            <div>{this.getUserEditContent()}</div>
        </div>
    );


    return (
      <Dialog
        open={this.props.open}
        modal={true}
        fullScreen
        actions={actions}
        autoScrollBodyContent={true}
        contentStyle={{ width: '80%', height: '70%', maxWidth: 'none', overflowy: 'auto' }}>
        <Paper>
          <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                Edit Log
              </Typography>
              <IconButton color="inherit" onClick={this.onClose} style={{ position: "relative", float: "right", }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
           <div>
           <Paper>
                <div className="row">
                    {content}
                </div>
            </Paper>
          </div>
        </Paper>
      </Dialog>
    );
  }
}
export default EditLogDialog;
